import { render, staticRenderFns } from "./AwardInfoComponent.vue?vue&type=template&id=05bcfb66&"
import script from "./AwardInfoComponent.vue?vue&type=script&lang=js&"
export * from "./AwardInfoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports